import { useEffect } from "react";

export const useActivityHistory = (
  resources,
  resourcesActions,
  currentPage,
  shouldRefresh,
  perPage = 25
) => {
  const {
    auditHistory: { pages: { [currentPage]: auditHistoryPage } } = {
      pages: { [currentPage]: {} }
    }
  } = resources;

  const auditHistoryFetched = auditHistoryPage?.isSuccess ?? false;
  const { fetchAuditHistory, refreshAuditHistory } = resourcesActions;

  useEffect(() => {
    refreshAuditHistory();
  }, [shouldRefresh, refreshAuditHistory]);

  useEffect(() => {
    if (!auditHistoryFetched) {
      fetchAuditHistory({
        page: currentPage,
        perPage: perPage
      });
    }
  }, [auditHistoryFetched, fetchAuditHistory, currentPage]);

  return { auditHistoryPage, auditHistoryFetched };
};
